import React, { useState, useEffect, useRef } from 'react';
import { FaMapMarkerAlt, FaHistory, FaBus, FaUsers, FaChartLine, FaMusic, FaMoneyBillWave, FaLaptopCode, FaExclamationTriangle, FaChevronDown, FaDownload } from 'react-icons/fa';
import Chart from 'chart.js/auto';
import { useLocation } from 'react-router-dom';
import { getAllCity } from '../../../FeatureRedux/citydetailReducer/getCityDetail';
import { useDispatch, useSelector } from 'react-redux';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import MapComponent from '../../Projectsfolder/NestComponent_Project/mapComponent_kml';
import ProjectProjection from '../../Projectsfolder/NestComponent_Project/projectProjection';

const sectionIcons = {
  'History': <FaHistory className="text-indigo-400" />,
  'Transport': <FaBus className="text-indigo-400" />,
  'Social Impact': <FaUsers className="text-indigo-400" />,
  'Population': <FaChartLine className="text-indigo-400" />,
  'Culture': <FaMusic className="text-indigo-400" />,
  'Economy': <FaMoneyBillWave className="text-indigo-400" />,
  'Technology': <FaLaptopCode className="text-indigo-400" />,
  'Infrastructure': <FaLaptopCode className="text-indigo-400" />,
  'Public': <FaUsers className="text-indigo-400" />
};

const ViewCitydetailData = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const location = useLocation();
  const { cityname, statee, country , projectId , projectiondata } = location.state || {};
  const dispatch = useDispatch();
  const sectionRefs = useRef({});
  const imageRefs = useRef({});
  const containerRef = useRef(null);
  const pdfRef = useRef(null);

  // Register section refs
  const registerSectionRef = (sectionId, element) => {
    if (element) {
      sectionRefs.current[sectionId] = element;
    }
  };

  // Register image refs
  const registerImageRef = (id, element) => {
    if (element) {
      imageRefs.current[id] = element;
    }
  };

  // Improved scroll to section function
  const scrollToSection = (sectionId) => {
    const container = containerRef.current;
    const element = sectionRefs.current[sectionId];
    
    if (container && element) {
      // Calculate the position relative to the container
      const containerRect = container.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      const scrollPosition = elementRect.top - containerRect.top + container.scrollTop - 80;
      
      container.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
      
      setActiveTab(sectionId);
      setMobileMenuOpen(false);
    }
  };


  

  // Handle scroll events
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setIsScrolled(container.scrollTop > 50);
      
      // Find which section is currently in view
      const containerRect = container.getBoundingClientRect();
      let currentSection = 'overview';
      let closestDistance = Infinity;
      
      Object.entries(sectionRefs.current).forEach(([sectionId, element]) => {
        if (element) {
          const elementRect = element.getBoundingClientRect();
          const elementTopRelativeToContainer = elementRect.top - containerRect.top;
          const elementBottomRelativeToContainer = elementRect.bottom - containerRect.top;
          
          // Check if element is in view
          if (elementTopRelativeToContainer <= 100 && elementBottomRelativeToContainer >= 100) {
            const distance = Math.abs(elementTopRelativeToContainer - 80);
            if (distance < closestDistance) {
              closestDistance = distance;
              currentSection = sectionId;
            }
          }
        }
      });
      
      setActiveTab(currentSection);
    };
    
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  // Load city data
  useEffect(() => {
    const state = statee;
    if (cityname && state && country) {
      dispatch(getAllCity({ cityname, state, country }));
    }
  }, [cityname, statee, country, dispatch]);

  const { data, error, isLoading } = useSelector(s => s.getAllCity);
  const cityData = data?.data?.city || {};
  const sectionsData = data?.data || {};

  // Function to download PDF

  const downloadPDF = () => {
  const element = pdfRef.current;

  const opt = {
    margin:       0,
    filename:     `${cityData.cityname || 'city'}_report.pdf`,
    image:        { type: 'jpeg', quality: 0.98 },
    html2canvas:  { scale: 2, useCORS: true },
    jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  };

  html2pdf().from(element).set(opt).save();
};
// const downloadPDF = async () => {
//   setIsGeneratingPDF(true);
//   try {
//     containerRef.current.scrollTo(0, 0);
//     await new Promise(resolve => setTimeout(resolve, 1000));

//     const element = pdfRef.current;

//     if (!element || !element.offsetHeight) {
//       alert('No content found to export.');
//       return;
//     }

//     // Hide elements you don’t want in the PDF
//     const originalStyles = {};
//     const elementsToHide = document.querySelectorAll('.no-print, .mobile-nav, .desktop-nav');
//     elementsToHide.forEach(el => {
//       originalStyles[el] = el.style.display;
//       el.style.display = 'none';
//     });

//     // Replace maps
//     const mapContainers = document.querySelectorAll('.map-container');
//     mapContainers.forEach(container => {
//       const staticMapImg = container.getAttribute('data-static-map');
//       if (staticMapImg) {
//         container.innerHTML = `<img src="${staticMapImg}" alt="Static Map" style="width:100%; height:100%; object-fit:cover;">`;
//       }
//     });

//     await new Promise(resolve => setTimeout(resolve, 500));

//     const fullCanvas = await html2canvas(element, {
//       scale: 2,
//       useCORS: true,
//       allowTaint: true,
//       scrollY: -window.scrollY,
//       imageTimeout: 15000,
//       ignoreElements: el => el.classList.contains('ignore-in-pdf')
//     });

//     // Restore hidden elements
//     elementsToHide.forEach(el => {
//       el.style.display = originalStyles[el];
//     });

//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const pageWidth = 210; // A4 width in mm
//     const pageHeight = 297; // A4 height in mm

//     const canvasWidth = fullCanvas.width;
//     const canvasHeight = fullCanvas.height;

//     const pageHeightPx = (pageHeight * canvasWidth) / pageWidth; // in px
//     let renderedHeight = 0;

//     while (renderedHeight < canvasHeight) {
//       const canvasSlice = document.createElement('canvas');
//       canvasSlice.width = canvasWidth;
//       canvasSlice.height = Math.min(pageHeightPx, canvasHeight - renderedHeight);

//       const context = canvasSlice.getContext('2d');
//       context.drawImage(
//         fullCanvas,
//         0,
//         renderedHeight,
//         canvasWidth,
//         canvasSlice.height,
//         0,
//         0,
//         canvasWidth,
//         canvasSlice.height
//       );

//       const imgData = canvasSlice.toDataURL('image/jpeg', 1.0);
//       const imgHeight = (canvasSlice.height * pageWidth) / canvasWidth;

//       pdf.addImage(imgData, 'JPEG', 0, 0, pageWidth, imgHeight);
//       renderedHeight += pageHeightPx;

//       if (renderedHeight < canvasHeight) {
//         pdf.addPage();
//       }
//     }

//     pdf.save(`${cityData.cityname || 'city'}_report.pdf`);
//   } catch (error) {
//     console.error('PDF generation error:', error);
//   } finally {
//     setIsGeneratingPDF(false);
//   }
// };






  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500 mb-4"></div>
          <p className="text-white text-lg">Loading city data.........</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white p-4">
        <FaExclamationTriangle className="text-red-500 text-5xl mb-4" />
        <h2 className="text-2xl font-bold mb-2">Error Loading City Data</h2>
        <p className="text-gray-300 mb-4">{error.message || 'Failed to fetch city details'}</p>
        <button 
          className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-300"
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
      </div>
    );
  }

  if (!cityData || Object.keys(cityData).length === 0) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white p-4">
        <h2 className="text-2xl font-bold mb-2">No City Data Found</h2>
        <p className="text-gray-300 mb-4">We couldn't find information for {cityname}</p>
      </div>
    );
  }

  // Handle image hover effects
  const handleMouseEnter = (id) => {
    const img = imageRefs.current[id];
    if (img) {
      img.style.transform = 'scale(1.05)';
    }
  };

  const handleMouseLeave = (id) => {
    const img = imageRefs.current[id];
    if (img) {
      img.style.transform = 'scale(1)';
    }
  };

  return (
    <div 
      ref={containerRef}
      className="bg-gray-900 text-gray-100" 
      style={{
        overflowY: 'scroll',
        height: '80vh',
        width: '100%',
        scrollbarWidth: 'px',
        msOverflowStyle: 'none'
      }}
    >
      {/* Floating Download Button */}
      <button
        onClick={downloadPDF}
        disabled={isGeneratingPDF}
        className="fixed bottom-8 right-8 z-50 bg-indigo-600 hover:bg-indigo-700 text-white p-4 rounded-full shadow-lg transition-all duration-300 flex items-center justify-center"
        title="Download PDF Report"
      >
        {isGeneratingPDF ?(
  <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
    <div className="bg-gray-800 p-6 rounded-lg max-w-md text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500 mx-auto mb-4"></div>
      <h3 className="text-xl font-semibold text-white mb-2">Generating PDF</h3>
      <p className="text-gray-300">This may take a moment...</p>
      <p className="text-gray-400 text-sm mt-2">Reducing quality to keep file size under 20MB</p>
    </div>
  </div>
): (
          <FaDownload className="text-xl" />
        )}
       
      </button>

      {/* Main content with PDF ref */}
      <div ref={pdfRef}>
        {/* Hero Section */}
        <div className="relative h-[70vh] min-h-[500px] overflow-hidden">
          <div className="absolute inset-0 bg-gray-900/60 z-10"></div>
          <img 
            src={cityData.imageUrl || 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'} 
            alt={cityData.cityname} 
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="relative z-20 h-full flex flex-col justify-end pb-16">
            <div className="container mx-auto px-4">
              <div className="max-w-3xl">
                <div className="inline-block bg-indigo-600/90 text-white px-4 py-1 rounded-full text-sm font-medium mb-4">
                  {cityData.country || 'City'}
                </div>
                <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white leading-tight">
                  {cityData.cityname || 'City'}
                </h1>
                <p className="text-xl text-gray-300 mb-8 max-w-2xl">
                  {cityData.description || 'Discover the rich culture and history of this city'}
                </p>
                <div className="flex flex-wrap gap-4">
                  <button 
                    onClick={() => scrollToSection('overview')}
                    className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300"
                  >
                    Explore City
                  </button>
                  <button 
                    onClick={() => scrollToSection('culture')}
                    className="bg-gray-800 hover:bg-gray-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300"
                  >
                    Discover Culture
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Navigation Toggle */}
        <div className="lg:hidden sticky top-0 z-50 bg-gray-900/95 backdrop-blur-sm border-b border-gray-800 no-print mobile-nav">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="w-full py-4 px-6 flex items-center justify-between text-white font-medium"
          >
            <span>Jump to Section</span>
            <FaChevronDown className={`transition-transform duration-300 ${mobileMenuOpen ? 'transform rotate-180' : ''}`} />
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-gray-800/95 backdrop-blur-sm border-b border-gray-700 z-40 no-print mobile-nav">
            <div className="container mx-auto px-4 py-2">
              <nav className="flex flex-col space-y-2">
                {Object.entries(sectionIcons).map(([section, icon]) => {
                  const sectionId = section.toLowerCase().replace(' ', '-');
                  const sectionDataKey = section.toLowerCase().replace(' ', '');
                  if (!sectionsData[sectionDataKey] || sectionsData[sectionDataKey].length === 0) return null;
                  
                  return (
                    <button
                      key={section}
                      onClick={() => scrollToSection(sectionId)}
                      className={`flex items-center whitespace-nowrap px-4 py-3 rounded-lg transition-all ${activeTab === sectionId ? 'bg-indigo-600 text-white' : 'hover:bg-gray-700 text-gray-300'}`}
                    >
                      <span className="mr-3">{icon}</span>
                      {section}
                    </button>
                  );
                })}
              </nav>
            </div>
          </div>
        )}
        
        {/* Desktop Navigation */}
        <div className={`hidden lg:block sticky top-0 z-50 transition-all duration-300 ${isScrolled ? ' backdrop-blur-sm shadow-lg py-2 border-gray-800' : 'bg-transparent py-4'} no-print desktop-nav`}>
          <div className="container mx-auto px-4">
            <nav className="flex overflow-x-auto scrollbar-hide space-x-1 justify-center">
              {Object.entries(sectionIcons).map(([section, icon]) => {
                const sectionId = section.toLowerCase().replace(' ', '-');
                const sectionDataKey = section.toLowerCase().replace(' ', '');
                if (!sectionsData[sectionDataKey] || sectionsData[sectionDataKey].length === 0) return null;
                
                return (
                  <button
                    key={section}
                    onClick={() => scrollToSection(sectionId)}
                    className={`flex items-center whitespace-nowrap px-5 py-3 rounded-lg transition-all ${activeTab === sectionId ? ' text-white shadow-md' : 'hover:bg-gray-800 text-gray-300'}`}
                  >
                    <span className="mr-2">{icon}</span>
                    {section}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

       

        {/* Main Content */}
        <div className="container mx-auto px-4 py-12 max-w-7xl">
          {/* Overview Section */}
          <section 
            id="overview" 
            ref={el => registerSectionRef('overview', el)}
            className="mb-20 scroll-mt-24"
          >
            <div className="flex items-center mb-8">
              <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                <FaMapMarkerAlt className="text-indigo-400 text-2xl" />
              </div>
              <h2 className="text-3xl font-bold text-white">City Overview</h2>
            </div>
            
            <div className="grid lg:grid-cols-2 gap-8 items-start">
              <div className="rounded-xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300">
                <img 
                  src={cityData.imageUrl || 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'} 
                  alt={cityData.cityname} 
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-2xl font-semibold text-white mb-4">About {cityData.cityname}</h3>
                  <p className="text-gray-300 leading-relaxed">
                    {cityData.description || 'No description available'}
                  </p>
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 hover:border-indigo-500 transition-colors duration-300">
                    <h4 className="font-medium text-gray-300 mb-1">Country</h4>
                    <p className="text-white font-medium">{cityData.country || 'N/A'}</p>
                  </div>
                  <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 hover:border-indigo-500 transition-colors duration-300">
                    <h4 className="font-medium text-gray-300 mb-1">State</h4>
                    <p className="text-white font-medium">{cityData.state || 'N/A'}</p>
                  </div>
                  <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 hover:border-indigo-500 transition-colors duration-300">
                    <h4 className="font-medium text-gray-300 mb-1">Latitude</h4>
                    <p className="text-white font-medium">{cityData.latitude || 'N/A'}</p>
                  </div>
                  <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 hover:border-indigo-500 transition-colors duration-300">
                    <h4 className="font-medium text-gray-300 mb-1">Longitude</h4>
                    <p className="text-white font-medium">{cityData.longitude || 'N/A'}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

{projectId && (
  <section 
    id="map" 
    ref={el => registerSectionRef('map', el)}
    className="mb-20 scroll-mt-24"
  >
    <div className="flex items-center mb-8">
      <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
        <FaMapMarkerAlt className="text-indigo-400 text-2xl" />
      </div>
      <h2 className="text-3xl font-bold text-white">Project Map</h2>
    </div>
    
    <div 
      className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden map-container"
      data-project-id={projectId}
      data-static-map="https://maps.googleapis.com/maps/api/staticmap?center=[LAT],[LNG]&zoom=12&size=800x500&maptype=roadmap&key=YOUR_API_KEY"
    >
      <div className="h-[500px] w-full">
        <MapComponent projectid={projectId} />
      </div>
    </div>
  </section>
)}

          {/* History Section */}
          {sectionsData.history?.length > 0 && (
            <section 
              id="history" 
              ref={el => registerSectionRef('history', el)}
              className="mb-20 scroll-mt-24 break-inside-avoid"
               
            >
              <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaHistory className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">History</h2>
              </div>
              
              <div className="grid md:grid-cols-2 gap-8">
                {sectionsData.history.map((item, index) => (
                  <div key={index} className="bg-gray-800/50 rounded-xl shadow-lg overflow-hidden transition-all duration-300 h-full flex flex-col hover:shadow-xl border border-gray-700 hover:border-indigo-500">
                    {item.imageUrl && (
                      <div className="h-48 overflow-hidden">
                        <img 
                          src={item.imageUrl} 
                          alt={item.title} 
                          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                        />
                      </div>
                    )}
                    <div className="p-6 flex-grow flex flex-col">
                      <h3 className="text-xl font-semibold mb-3 text-white">{item.title || 'Historical Information'}</h3>
                      <p className="text-gray-300 flex-grow">{item.content || 'No historical details available'}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Transport Section */}
          {sectionsData.transport?.length > 0 && (
            <section 
              id="transport" 
              ref={el => registerSectionRef('transport', el)}
              className="mb-20 scroll-mt-24"
            >
              <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaBus className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">Transport</h2>
              </div>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {sectionsData.transport.map((item, index) => (
                  <div key={index} className="bg-gray-800/50 rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 h-full border border-gray-700 hover:border-indigo-500">
                    {item.imageUrl && (
                      <div className="h-40 overflow-hidden">
                        <img src={item.imageUrl} alt={item.type} className="w-full h-full object-cover" />
                      </div>
                    )}
                    <div className="p-5">
                      <div className="flex items-center mb-3">
                        <div className="bg-indigo-600/30 p-2 rounded-lg mr-3">
                          <FaBus className="text-indigo-400" />
                        </div>
                        <h3 className="text-lg font-semibold text-white">{item.type || 'Transport'}</h3>
                      </div>
                      <p className="text-gray-300">{item.details || 'No transport details available'}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}


          {projectiondata && (
             <div >
            <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaBus className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">Projection Data</h2>
              </div>
           
            <ProjectProjection projectiondata={projectiondata} showtwo={true}/>
          </div>)}

          {/* Social Impact Section */}
          {sectionsData.socialImpact?.length > 0 && (
            <section 
              id="social-impact" 
              ref={el => registerSectionRef('social-impact', el)}
              className="mb-20 scroll-mt-24"
            >
              <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaUsers className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">Social Impact</h2>
              </div>
              
              <div className="grid md:grid-cols-2 gap-8">
                {sectionsData.socialImpact.map((item, index) => (
                  <div key={index} className="bg-gray-800/50 rounded-xl shadow-lg overflow-hidden flex flex-col md:flex-row h-full hover:shadow-xl transition-all duration-300 border border-gray-700 hover:border-indigo-500">
                    {item.imageUrl && (
                      <div className="md:w-1/3 h-48 md:h-auto overflow-hidden">
                        <img src={item.imageUrl} alt={item.aspect} className="w-full h-full object-cover" />
                      </div>
                    )}
                    <div className="p-6 md:w-2/3">
                      <h3 className="text-xl font-semibold mb-3 text-white">{item.aspect || 'Social Aspect'}</h3>
                      <p className="text-gray-300">{item.impact || 'No impact information available'}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Population Section */}
          {sectionsData.population?.length > 0 && (
            <section 
              id="population" 
              ref={el => registerSectionRef('population', el)}
              className="mb-20 scroll-mt-24"
            >
              <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaChartLine className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">Population</h2>
              </div>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                {sectionsData.population.map((item, index) => (
                  <div key={index} className="bg-gray-800/50 rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 border border-gray-700 hover:border-indigo-500">
                    <h3 className="text-xl font-semibold mb-3 text-white">Population {item.year ? `in ${item.year}` : ''}</h3>
                    {item.count ? (
                      <>
                        <p className="text-3xl font-bold text-indigo-400 mb-3">{item.count.toLocaleString()}</p>
                        <p className="text-gray-300">{item.notes || ''}</p>
                      </>
                    ) : (
                      <p className="text-gray-400 italic">No population data available</p>
                    )}
                  </div>
                ))}
              </div>
              
              <div className="bg-gray-800/50 p-6 rounded-xl shadow-lg border border-gray-700">
                <h3 className="text-xl font-semibold mb-4 text-white">Population Growth</h3>
                <div className="h-64">
                  <PopulationChart populationData={sectionsData.population} />
                </div>
              </div>
            </section>
          )}

          {/* Culture Section */}
          {sectionsData.culture?.length > 0 && (
            <section 
              id="culture" 
              ref={el => registerSectionRef('culture', el)}
              className="mb-20 scroll-mt-24"
            >
              <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaMusic className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">Culture</h2>
              </div>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {sectionsData.culture.map((item, index) => (
                  <div key={index} className="bg-gray-800/50 rounded-xl shadow-lg overflow-hidden group h-full hover:shadow-xl transition-all duration-300 border border-gray-700 hover:border-indigo-500">
                    {item.imageUrl ? (
                      <div className="relative overflow-hidden h-48">
                        <img 
                          src={item.imageUrl} 
                          alt={item.aspect} 
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-70"></div>
                        <h3 className="absolute bottom-4 left-4 text-white text-xl font-semibold">{item.aspect || 'Cultural Aspect'}</h3>
                      </div>
                    ) : (
                      <div className="h-48 bg-gray-700 flex items-center justify-center">
                        <h3 className="text-white text-xl font-semibold">{item.aspect || 'Cultural Aspect'}</h3>
                      </div>
                    )}
                    <div className="p-5">
                      <p className="text-gray-300">{item.details || 'No cultural details available'}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Economy Section */}
          {sectionsData.economy?.length > 0 && (
            <section 
              id="economy" 
              ref={el => registerSectionRef('economy', el)}
              className="mb-20 scroll-mt-24"
            >
              <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaMoneyBillWave className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">Economy</h2>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6">
                {sectionsData.economy.map((item, index) => (
                  <div key={index} className="bg-gray-800/50 rounded-xl shadow-lg p-6 border-l-4 border-indigo-500 hover:shadow-xl transition-all duration-300">
                    <h3 className="text-xl font-semibold mb-3 text-white">{item.sector || 'Economic Sector'}</h3>
                    <p className="text-gray-300">{item.info || 'No economic information available'}</p>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Technology Section */}
          {sectionsData.technology?.length > 0 && (
            <section 
              id="technology" 
              ref={el => registerSectionRef('technology', el)}
              className="mb-20 scroll-mt-24"
            >
              <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaLaptopCode className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">Technology</h2>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6">
                {sectionsData.technology.map((item, index) => {
                  const imgId = `tech-img-${index}`;
                  return (
                    <div 
                      key={index} 
                      className="relative rounded-xl overflow-hidden h-64 shadow-lg hover:shadow-xl transition-all duration-300"
                      onMouseEnter={() => handleMouseEnter(imgId)}
                      onMouseLeave={() => handleMouseLeave(imgId)}
                    >
                      {item.imageUrl ? (
                        <img 
                          ref={el => registerImageRef(imgId, el)}
                          src={item.imageUrl} 
                          alt={item.field} 
                          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500"
                        />
                      ) : (
                        <div className="absolute inset-0 w-full h-full bg-gray-700"></div>
                      )}
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-80"></div>
                      <div className="absolute inset-0 p-6 flex flex-col justify-end">
                        <h3 className="text-white text-xl font-semibold mb-2">{item.field || 'Technology'}</h3>
                        <p className="text-gray-200">
                          {item.description || 'No technology details available'}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          )}

          {/* Infrastructure Section */}
          {sectionsData.infrastructure?.length > 0 && (
            <section 
              id="infrastructure" 
              ref={el => registerSectionRef('infrastructure', el)}
              className="mb-20 scroll-mt-24"
            >
              <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaLaptopCode className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">Infrastructure</h2>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6">
                {sectionsData.infrastructure.map((item, index) => {
                  const imgId = `infra-img-${index}`;
                  return (
                    <div 
                      key={index} 
                      className="relative rounded-xl overflow-hidden h-64 shadow-lg hover:shadow-xl transition-all duration-300"
                      onMouseEnter={() => handleMouseEnter(imgId)}
                      onMouseLeave={() => handleMouseLeave(imgId)}
                    >
                      {item.imageUrl ? (
                        <img 
                          ref={el => registerImageRef(imgId, el)}
                          src={item.imageUrl} 
                          alt={item.field} 
                          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500"
                        />
                      ) : (
                        <div className="absolute inset-0 w-full h-full bg-gray-700"></div>
                      )}
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-80"></div>
                      <div className="absolute inset-0 p-6 flex flex-col justify-end">
                        <h3 className="text-white text-xl font-semibold mb-2">{item.field || 'Infrastructure'}</h3>
                        <p className="text-gray-200">
                          {item.description || 'No infrastructure details available'}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          )}

          {/* Public Section */}
          {sectionsData.public?.length > 0 && (
            <section 
              id="public" 
              ref={el => registerSectionRef('public', el)}
              className="mb-20 scroll-mt-24"
            >
              <div className="flex items-center mb-8">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
                  <FaUsers className="text-indigo-400 text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-white">Public</h2>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6">
                {sectionsData.public.map((item, index) => (
                  <div key={index} className="bg-gray-800/50 rounded-xl shadow-lg p-6 border-l-4 border-indigo-500 hover:shadow-xl transition-all duration-300">
                    <h3 className="text-xl font-semibold mb-3 text-white">{item.field || 'Public'}</h3>
                    <p className="text-gray-300">{item.description || 'No public information available'}</p>
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

// Chart Component using Chart.js
const PopulationChart = ({ populationData }) => {
  const chartRef = useRef(null);
  
  useEffect(() => {
    if (!chartRef.current || !populationData || populationData.length === 0) return;

    const ctx = chartRef.current.getContext('2d');
    
    const sortedData = [...populationData].sort((a, b) => (a.year || 0) - (b.year || 0));
    
    const chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: sortedData.map(item => item.year ? item.year.toString() : ''),
        datasets: [{
          label: 'Population',
          data: sortedData.map(item => item.count || 0),
          backgroundColor: 'rgba(99, 102, 241, 0.2)',
          borderColor: 'rgba(99, 102, 241, 1)',
          borderWidth: 2,
          tension: 0.3,
          pointBackgroundColor: 'rgba(99, 102, 241, 1)',
          pointRadius: 4,
          pointHoverRadius: 6,
          fill: true
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            backgroundColor: 'rgba(17, 24, 39, 0.95)',
            titleColor: '#ffffff',
            bodyColor: '#e5e7eb',
            borderColor: 'rgba(255, 255, 255, 0.1)',
            borderWidth: 1,
            callbacks: {
              label: function(context) {
                return `Population: ${context.raw.toLocaleString()}`;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              color: '#9ca3af',
              callback: function(value) {
                return value.toLocaleString();
              }
            },
            grid: {
              color: 'rgba(255, 255, 255, 0.05)'
            }
          },
          x: {
            ticks: {
              color: '#9ca3af'
            },
            grid: {
              display: false
            }
          }
        }
      }
    });

    return () => {
      chart.destroy();
    };
  }, [populationData]);

  if (!populationData || populationData.length === 0) {
    return (
      <div className="h-full w-full flex items-center justify-center bg-gray-700 rounded">
        <p className="text-gray-400 italic">No population data available for chart</p>
      </div>
    );
  }

  return (
    <div className="h-full w-full">
      <canvas ref={chartRef} />
    </div>
  );
};

export default ViewCitydetailData;
























// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import { 
//   FaMapMarkerAlt, FaHistory, FaBus, FaUsers, FaChartLine, 
//   FaMusic, FaMoneyBillWave, FaLaptopCode, FaExclamationTriangle, 
//   FaChevronDown, FaDownload 
// } from 'react-icons/fa';
// import Chart from 'chart.js/auto';
// import { useLocation } from 'react-router-dom';
// import { getAllCity } from '../../../FeatureRedux/citydetailReducer/getCityDetail';
// import { useDispatch, useSelector } from 'react-redux';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import Map from 'react-map-gl';
// import NavigationControl from 'react-map-gl/dist/esm/components/navigation-control';
// import FullscreenControl from 'react-map-gl/dist/esm/components/fullscreen-control';
// import Source from 'react-map-gl/dist/esm/components/source';
// import Layer from 'react-map-gl/dist/esm/components/layer';
// import JSZip from 'jszip';
// import { toGeoJSON } from '@mapbox/togeojson';
// import { getallkml } from '../../../FeatureRedux/project/getKmlReducer';

// const sectionIcons = {
//   'History': <FaHistory className="text-indigo-400" />,
//   'Transport': <FaBus className="text-indigo-400" />,
//   'Social Impact': <FaUsers className="text-indigo-400" />,
//   'Population': <FaChartLine className="text-indigo-400" />,
//   'Culture': <FaMusic className="text-indigo-400" />,
//   'Economy': <FaMoneyBillWave className="text-indigo-400" />,
//   'Technology': <FaLaptopCode className="text-indigo-400" />,
//   'Infrastructure': <FaLaptopCode className="text-indigo-400" />,
//   'Public': <FaUsers className="text-indigo-400" />
// };

// const ViewCitydetailData = () => {
//   const [activeTab, setActiveTab] = useState('overview');
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
//   const location = useLocation();
//   const { cityname, statee, country, projectId } = location.state || {};
//   const dispatch = useDispatch();
//   const sectionRefs = useRef({});
//   const imageRefs = useRef({});
//   const containerRef = useRef(null);
//   const pdfRef = useRef(null);
//   const mapRef = useRef(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [multipleGeoJson, setMultipleGeoJson] = useState([]);
//   const [viewState, setViewState] = useState({
//     zoom: 2,
//     latitude: 28.6139,
//     longitude: 77.2090,
//   });

//   // KML styling
//   const kmlColor = '#3b82f6';
//   const kmlOpacity = 0.5;

//   // Memoized selector to prevent unnecessary re-renders
//   const kmlData = useSelector((state) => state.getallkml.data || {}, (prev, next) => {
//     return JSON.stringify(prev) === JSON.stringify(next);
//   });

//   const { data, isLoading: cityLoading } = useSelector(s => s.getAllCity);
//   const cityData = data?.data?.city || {};
//   const sectionsData = data?.data || {};

//   // Register section refs
//   const registerSectionRef = (sectionId, element) => {
//     if (element) {
//       sectionRefs.current[sectionId] = element;
//     }
//   };

//   // Register image refs
//   const registerImageRef = (id, element) => {
//     if (element) {
//       imageRefs.current[id] = element;
//     }
//   };

//   // Scroll to section function
//   const scrollToSection = (sectionId) => {
//     const container = containerRef.current;
//     const element = sectionRefs.current[sectionId];
    
//     if (container && element) {
//       const containerRect = container.getBoundingClientRect();
//       const elementRect = element.getBoundingClientRect();
//       const scrollPosition = elementRect.top - containerRect.top + container.scrollTop - 80;
      
//       container.scrollTo({
//         top: scrollPosition,
//         behavior: 'smooth'
//       });
      
//       setActiveTab(sectionId);
//       setMobileMenuOpen(false);
//     }
//   };

//   // Load KML data
//   useEffect(() => {
//     const loadKml = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         await dispatch(getallkml(projectId)).unwrap();
//       } catch (err) {
//         console.error("KML fetch error:", err);
//         setError("Failed to load KML data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (projectId) {
//       loadKml();
//     }
//   }, [dispatch, projectId]);

//   // Convert KML/KMZ to GeoJSON with proper error handling
// // Modify the fetchAndConvertKML function to include better validation
// const fetchAndConvertKML = async (url) => {
//   try {
//     // ... existing fetch code ...

//     const geoJson = toGeoJSON(kmlData);
    
//     // Enhanced validation
//     if (!geoJson || !geoJson.type || geoJson.type !== 'FeatureCollection') {
//       throw new Error("Invalid GeoJSON: Not a FeatureCollection");
//     }
    
//     if (!geoJson.features || !Array.isArray(geoJson.features)) {
//       throw new Error("Invalid GeoJSON: Missing features array");
//     }
    
//     // Filter out invalid features
//     const validFeatures = geoJson.features.filter(feature => 
//       feature && 
//       feature.type === 'Feature' && 
//       feature.geometry && 
//       feature.geometry.coordinates
//     );
    
//     if (validFeatures.length === 0) {
//       throw new Error("No valid features found in GeoJSON");
//     }
    
//     return {
//       ...geoJson,
//       features: validFeatures
//     };
    
//   } catch (err) {
//     console.warn(`KML processing error (${url}):`, err.message);
//     return null;
//   }
// };

//   // Process all KML files
//   useEffect(() => {
//     if (!kmlData?.kml?.length) return;

//     const fetchAllKMLs = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const kmlUrls = kmlData.kml.map((item) => item.url);
//         const geoJsonList = await Promise.all(kmlUrls.map(fetchAndConvertKML));
//         const validGeoJsons = geoJsonList.filter(Boolean);

//         setMultipleGeoJson(validGeoJsons);

//         if (validGeoJsons.length > 0 && validGeoJsons[0].features?.length > 0) {
//           const firstFeature = validGeoJsons[0].features[0];
//           let newLatitude, newLongitude;

//           if (firstFeature.geometry) {
//             switch (firstFeature.geometry.type) {
//               case "Point":
//                 [newLongitude, newLatitude] = firstFeature.geometry.coordinates;
//                 break;
//               case "Polygon":
//                 [newLongitude, newLatitude] = firstFeature.geometry.coordinates[0][0];
//                 break;
//               case "LineString":
//                 [newLongitude, newLatitude] = firstFeature.geometry.coordinates[0];
//                 break;
//               default:
//                 break;
//             }
//           }

//           if (newLatitude && newLongitude && mapRef.current) {
//             mapRef.current.easeTo({
//               center: [newLongitude, newLatitude],
//               zoom: 12,
//               duration: 8000,
//               easing: (t) => t * (2 - t),
//             });
//           }
//         }

//         if (validGeoJsons.length === 0) {
//           setError("KMLs processed but none could be displayed.");
//         }
//       } catch (err) {
//         console.error("Unexpected error during KML processing:", err);
//         setError("Unexpected error during KML processing.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllKMLs();
//   }, [kmlData]);

//   // Handle scroll events
//   useEffect(() => {
//     const container = containerRef.current;
//     if (!container) return;

//     const handleScroll = () => {
//       setIsScrolled(container.scrollTop > 50);
      
//       const containerRect = container.getBoundingClientRect();
//       let currentSection = 'overview';
//       let closestDistance = Infinity;
      
//       Object.entries(sectionRefs.current).forEach(([sectionId, element]) => {
//         if (element) {
//           const elementRect = element.getBoundingClientRect();
//           const elementTopRelativeToContainer = elementRect.top - containerRect.top;
//           const elementBottomRelativeToContainer = elementRect.bottom - containerRect.top;
          
//           if (elementTopRelativeToContainer <= 100 && elementBottomRelativeToContainer >= 100) {
//             const distance = Math.abs(elementTopRelativeToContainer - 80);
//             if (distance < closestDistance) {
//               closestDistance = distance;
//               currentSection = sectionId;
//             }
//           }
//         }
//       });
      
//       setActiveTab(currentSection);
//     };
    
//     container.addEventListener('scroll', handleScroll);
//     return () => container.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Load city data
//   useEffect(() => {
//     const state = statee;
//     if (cityname && state && country) {
//       dispatch(getAllCity({ cityname, state, country }));
//     }
//   }, [cityname, statee, country, dispatch]);

//   // Download PDF function with enhanced error handling
//   const downloadPDF = async () => {
//     setIsGeneratingPDF(true);
//     try {
//       if (!pdfRef.current) {
//         throw new Error("PDF reference not available");
//       }
      
//       containerRef.current?.scrollTo(0, 0);
//       await new Promise(resolve => setTimeout(resolve, 1000));
      
//       const element = pdfRef.current;
//       const originalStyles = {};
//       const elementsToHide = document.querySelectorAll('.no-print, .mobile-nav, .desktop-nav');
      
//       elementsToHide.forEach(el => {
//         originalStyles[el] = el.style.display;
//         el.style.display = 'none';
//       });

//       const mapContainers = document.querySelectorAll('.map-container');
//       mapContainers.forEach(container => {
//         const staticMapImg = container.getAttribute('data-static-map');
//         if (staticMapImg) {
//           container.innerHTML = `<img src="${staticMapImg}" alt="Static Map" style="width:100%; height:100%; object-fit:cover;">`;
//         }
//       });

//       await new Promise(resolve => setTimeout(resolve, 500));
      
//       const canvas = await html2canvas(element, {
//         scale: 1,
//         useCORS: true,
//         allowTaint: true,
//         scrollY: -window.scrollY,
//         logging: false,
//         imageTimeout: 15000,
//         ignoreElements: (element) => {
//           return element.classList.contains('ignore-in-pdf');
//         }
//       }).catch(err => {
//         console.error("HTML2Canvas error:", err);
//         throw new Error("Failed to capture page content");
//       });
      
//       elementsToHide.forEach(el => {
//         if (originalStyles[el] !== undefined) {
//           el.style.display = originalStyles[el];
//         }
//       });

//       mapContainers.forEach(container => {
//         const projectId = container.getAttribute('data-project-id');
//         if (projectId) {
//           container.innerHTML = `<Map projectid="${projectId}" />`;
//         }
//       });
      
//       const imgData = canvas.toDataURL('image/jpeg', 0.7);
//       const pdf = new jsPDF('p', 'mm', 'a4');
//       const imgProps = pdf.getImageProperties(imgData);
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      
//       pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
//       pdf.save(`${cityData.cityname || 'city'}_report.pdf`);
//     } catch (error) {
//       console.error('Error generating PDF:', error);
//       setError(`PDF generation failed: ${error.message}`);
//     } finally {
//       setIsGeneratingPDF(false);
//     }
//   };

//   // Handle image hover effects
//   const handleMouseEnter = (id) => {
//     const img = imageRefs.current[id];
//     if (img) {
//       img.style.transform = 'scale(1.05)';
//     }
//   };

//   const handleMouseLeave = (id) => {
//     const img = imageRefs.current[id];
//     if (img) {
//       img.style.transform = 'scale(1)';
//     }
//   };

//   if (cityLoading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gray-900">
//         <div className="text-center">
//           <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500 mb-4"></div>
//           <p className="text-white text-lg">Loading city data...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white p-4">
//         <FaExclamationTriangle className="text-red-500 text-5xl mb-4" />
//         <h2 className="text-2xl font-bold mb-2">Error Loading City Data</h2>
//         <p className="text-gray-300 mb-4">{error}</p>
//         <button 
//           className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-300"
//           onClick={() => window.location.reload()}
//         >
//           Try Again
//         </button>
//       </div>
//     );
//   }

//   if (!cityData || Object.keys(cityData).length === 0) {
//     return (
//       <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white p-4">
//         <h2 className="text-2xl font-bold mb-2">No City Data Found</h2>
//         <p className="text-gray-300 mb-4">We couldn't find information for {cityname}</p>
//       </div>
//     );
//   }

//   return (
//     <div 
//       ref={containerRef}
//       className="bg-gray-900 text-gray-100" 
//       style={{
//         overflowY: 'scroll',
//         height: '80vh',
//         width: '100%',
//         scrollbarWidth: 'thin',
//         msOverflowStyle: 'none'
//       }}
//     >
//       {/* Floating Download Button */}
//       <button
//         onClick={downloadPDF}
//         disabled={isGeneratingPDF}
//         className="fixed bottom-8 right-8 z-50 bg-indigo-600 hover:bg-indigo-700 text-white p-4 rounded-full shadow-lg transition-all duration-300 flex items-center justify-center"
//         title="Download PDF Report"
//       >
//         {isGeneratingPDF ? (
//           <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
//             <div className="bg-gray-800 p-6 rounded-lg max-w-md text-center">
//               <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500 mx-auto mb-4"></div>
//               <h3 className="text-xl font-semibold text-white mb-2">Generating PDF</h3>
//               <p className="text-gray-300">This may take a moment...</p>
//             </div>
//           </div>
//         ) : (
//           <FaDownload className="text-xl" />
//         )}
//       </button>

//       {/* Main content with PDF ref */}
//       <div ref={pdfRef}>
//         {/* Hero Section */}
//         <div className="relative h-[70vh] min-h-[500px] overflow-hidden">
//           <div className="absolute inset-0 bg-gray-900/60 z-10"></div>
//           <img 
//             src={cityData.imageUrl || 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'} 
//             alt={cityData.cityname} 
//             className="absolute inset-0 w-full h-full object-cover object-center"
//           />
//           <div className="relative z-20 h-full flex flex-col justify-end pb-16">
//             <div className="container mx-auto px-4">
//               <div className="max-w-3xl">
//                 <div className="inline-block bg-indigo-600/90 text-white px-4 py-1 rounded-full text-sm font-medium mb-4">
//                   {cityData.country || 'City'}
//                 </div>
//                 <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white leading-tight">
//                   {cityData.cityname || 'City'}
//                 </h1>
//                 <p className="text-xl text-gray-300 mb-8 max-w-2xl">
//                   {cityData.description || 'Discover the rich culture and history of this city'}
//                 </p>
//                 <div className="flex flex-wrap gap-4">
//                   <button 
//                     onClick={() => scrollToSection('overview')}
//                     className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300"
//                   >
//                     Explore City
//                   </button>
//                   <button 
//                     onClick={() => scrollToSection('culture')}
//                     className="bg-gray-800 hover:bg-gray-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300"
//                   >
//                     Discover Culture
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Mobile Navigation Toggle */}
//         <div className="lg:hidden sticky top-0 z-50 bg-gray-900/95 backdrop-blur-sm border-b border-gray-800 no-print mobile-nav">
//           <button
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             className="w-full py-4 px-6 flex items-center justify-between text-white font-medium"
//           >
//             <span>Jump to Section</span>
//             <FaChevronDown className={`transition-transform duration-300 ${mobileMenuOpen ? 'transform rotate-180' : ''}`} />
//           </button>
//         </div>

//         {/* Mobile Navigation Menu */}
//         {mobileMenuOpen && (
//           <div className="lg:hidden bg-gray-800/95 backdrop-blur-sm border-b border-gray-700 z-40 no-print mobile-nav">
//             <div className="container mx-auto px-4 py-2">
//               <nav className="flex flex-col space-y-2">
//                 {Object.entries(sectionIcons).map(([section, icon]) => {
//                   const sectionId = section.toLowerCase().replace(' ', '-');
//                   const sectionDataKey = section.toLowerCase().replace(' ', '');
//                   if (!sectionsData[sectionDataKey] || sectionsData[sectionDataKey].length === 0) return null;
                  
//                   return (
//                     <button
//                       key={section}
//                       onClick={() => scrollToSection(sectionId)}
//                       className={`flex items-center whitespace-nowrap px-4 py-3 rounded-lg transition-all ${activeTab === sectionId ? 'bg-indigo-600 text-white' : 'hover:bg-gray-700 text-gray-300'}`}
//                     >
//                       <span className="mr-3">{icon}</span>
//                       {section}
//                     </button>
//                   );
//                 })}
//               </nav>
//             </div>
//           </div>
//         )}
        
//         {/* Desktop Navigation */}
//         <div className={`hidden lg:block sticky top-0 z-50 transition-all duration-300 ${isScrolled ? ' backdrop-blur-sm shadow-lg py-2 border-gray-800' : 'bg-transparent py-4'} no-print desktop-nav`}>
//           <div className="container mx-auto px-4">
//             <nav className="flex overflow-x-auto scrollbar-hide space-x-1 justify-center">
//               {Object.entries(sectionIcons).map(([section, icon]) => {
//                 const sectionId = section.toLowerCase().replace(' ', '-');
//                 const sectionDataKey = section.toLowerCase().replace(' ', '');
//                 if (!sectionsData[sectionDataKey] || sectionsData[sectionDataKey].length === 0) return null;
                
//                 return (
//                   <button
//                     key={section}
//                     onClick={() => scrollToSection(sectionId)}
//                     className={`flex items-center whitespace-nowrap px-5 py-3 rounded-lg transition-all ${activeTab === sectionId ? ' text-white shadow-md' : 'hover:bg-gray-800 text-gray-300'}`}
//                   >
//                     <span className="mr-2">{icon}</span>
//                     {section}
//                   </button>
//                 );
//               })}
//             </nav>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="container mx-auto px-4 py-12 max-w-7xl">
//           {/* Overview Section */}
//           <section 
//             id="overview" 
//             ref={el => registerSectionRef('overview', el)}
//             className="mb-20 scroll-mt-24"
//           >
//             <div className="flex items-center mb-8">
//               <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
//                 <FaMapMarkerAlt className="text-indigo-400 text-2xl" />
//               </div>
//               <h2 className="text-3xl font-bold text-white">City Overview</h2>
//             </div>
            
//             <div className="grid lg:grid-cols-2 gap-8 items-start">
//               <div className="rounded-xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300">
//                 <img 
//                   src={cityData.imageUrl || 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'} 
//                   alt={cityData.cityname} 
//                   className="w-full h-full object-cover"
//                 />
//               </div>
              
//               <div className="space-y-6">
//                 <div>
//                   <h3 className="text-2xl font-semibold text-white mb-4">About {cityData.cityname}</h3>
//                   <p className="text-gray-300 leading-relaxed">
//                     {cityData.description || 'No description available'}
//                   </p>
//                 </div>
                
//                 <div className="grid grid-cols-2 gap-4">
//                   <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 hover:border-indigo-500 transition-colors duration-300">
//                     <h4 className="font-medium text-gray-300 mb-1">Country</h4>
//                     <p className="text-white font-medium">{cityData.country || 'N/A'}</p>
//                   </div>
//                   <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 hover:border-indigo-500 transition-colors duration-300">
//                     <h4 className="font-medium text-gray-300 mb-1">State</h4>
//                     <p className="text-white font-medium">{cityData.state || 'N/A'}</p>
//                   </div>
//                   <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 hover:border-indigo-500 transition-colors duration-300">
//                     <h4 className="font-medium text-gray-300 mb-1">Latitude</h4>
//                     <p className="text-white font-medium">{cityData.latitude || 'N/A'}</p>
//                   </div>
//                   <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 hover:border-indigo-500 transition-colors duration-300">
//                     <h4 className="font-medium text-gray-300 mb-1">Longitude</h4>
//                     <p className="text-white font-medium">{cityData.longitude || 'N/A'}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>

//           {/* Map Section */}
//           {projectId && (
//             <section 
//               id="map" 
//               ref={el => registerSectionRef('map', el)}
//               className="mb-20 scroll-mt-24"
//             >
//               <div className="flex items-center mb-8">
//                 <div className="bg-indigo-600/20 p-3 rounded-lg mr-4">
//                   <FaMapMarkerAlt className="text-indigo-400 text-2xl" />
//                 </div>
//                 <h2 className="text-3xl font-bold text-white">Project Map</h2>
//               </div>
              
//               <div 
//                 className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden map-container"
//                 data-project-id={projectId}
//                 data-static-map="https://maps.googleapis.com/maps/api/staticmap?center=[LAT],[LNG]&zoom=12&size=800x500&maptype=roadmap&key=YOUR_API_KEY"
//               >
//                 <div className="h-[500px] w-full">
//                   <div style={{ height: "100%", width: "100%" }}>
//                     {loading && (
//                       <div className="text-gray-400 text-center p-2 text-sm">
//                         ⏳ Loading KML data...
//                       </div>
//                     )}

//                  {!loading && error && (
//                          <div style={{ color: "orange", textAlign: "center", padding: "8px", fontSize: "14px" }}>
//                            ⚠️ {error}
//                            <button
//                              onClick={() => dispatch(getallkml(projectId))}
//                              style={{
//                                marginLeft: "10px",
//                                padding: "4px 8px",
//                                borderRadius: "4px",
//                                backgroundColor: "#007bff",
//                                color: "#fff",
//                                border: "none",
//                                cursor: "pointer",
//                              }}
//                            >
//                              Retry
//                            </button>
//                          </div>
//                        )}

//                     {!loading && multipleGeoJson.length === 0 && !error && (
//                       <div className="text-gray-400 text-center p-2 text-sm">
//                         No KML data available to display.
//                       </div>
//                     )}

//                     <Map
//                             ref={mapRef}
//                             {...viewState}
//                             projection="globe"
//                             mapboxAccessToken="pk.eyJ1IjoibmlraXRhY2hhdWhhbjEyMyIsImEiOiJjbGwwaWxrdzEwZW02M2pxcjN4eHo1bDR1In0.I4yZh8CAQOz2c63IsCBOpg"
//                             style={{ width: "100%", height: "100%", borderRadius: "10px" }}
//                             mapStyle="mapbox://styles/mapbox/satellite-streets-v12"
//                             onMove={(evt) => setViewState(evt.viewState)}
//                           >
//                             <NavigationControl position="top-right" />
//                             <FullscreenControl position="top-right" />
                    
//                             {multipleGeoJson.map((geoJson, index) => (
//                               <Source key={`source-${index}`} id={`source-${index}`} type="geojson" data={geoJson}>
//                                 {Array.isArray(geoJson.features) &&
//                                   geoJson.features.map((feature, idx) => {
//                                     try {
//                                       const geometryType = feature?.geometry?.type;
//                                       if (!geometryType) return null;
                    
//                                       let layerProps = {};
//                                       switch (geometryType) {
//                                         case "LineString":
//                                           layerProps = {
//                                             type: "line",
//                                             paint: {
//                                               "line-color": "#ff0000",
//                                               "line-width": 3,
//                                               "line-opacity": 1,
//                                             },
//                                           };
//                                           break;
//                                         case "Polygon":
//                                         case "MultiPolygon":
//                                           layerProps = {
//                                             type: "fill",
//                                             paint: {
//                                               "fill-color": kmlColor || "#0000ff",
//                                               "fill-opacity": kmlOpacity ?? 0.4,
//                                             },
//                                           };
//                                           break;
//                                         case "Point":
//                                           layerProps = {
//                                             type: "circle",
//                                             paint: {
//                                               "circle-radius": 6,
//                                               "circle-color": "#ff0000",
//                                             },
//                                           };
//                                           break;
//                                         default:
//                                           return null;
//                                       }
                    
//                                       return (
//                                         <Layer key={`layer-${index}-${idx}`} id={`layer-${index}-${idx}`} {...layerProps} />
//                                       );
//                                     } catch (layerErr) {
//                                       console.warn("Layer rendering failed:", layerErr);
//                                       return null;
//                                     }
//                                   })}
//                               </Source>
//                             ))}
//                           </Map>
//                   </div>
//                 </div>
//               </div>
//             </section>
//           )}

//           {/* Other sections would go here */}
//         </div>
//       </div>
//     </div>
//   );
// };

// // Population Chart Component with error handling
// const PopulationChart = ({ populationData }) => {
//   const chartRef = useRef(null);
//   const chartInstance = useRef(null);
  
//   useEffect(() => {
//     if (!chartRef.current || !populationData || populationData.length === 0) return;

//     const ctx = chartRef.current.getContext('2d');
//     if (!ctx) return;

//     // Destroy previous chart instance if exists
//     if (chartInstance.current) {
//       chartInstance.current.destroy();
//     }

//     try {
//       const sortedData = [...populationData].sort((a, b) => (a.year || 0) - (b.year || 0));
      
//       chartInstance.current = new Chart(ctx, {
//         type: 'line',
//         data: {
//           labels: sortedData.map(item => item.year ? item.year.toString() : ''),
//           datasets: [{
//             label: 'Population',
//             data: sortedData.map(item => item.count || 0),
//             backgroundColor: 'rgba(99, 102, 241, 0.2)',
//             borderColor: 'rgba(99, 102, 241, 1)',
//             borderWidth: 2,
//             tension: 0.3,
//             pointBackgroundColor: 'rgba(99, 102, 241, 1)',
//             pointRadius: 4,
//             pointHoverRadius: 6,
//             fill: true
//           }]
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: {
//               display: false
//             },
//             tooltip: {
//               backgroundColor: 'rgba(17, 24, 39, 0.95)',
//               titleColor: '#ffffff',
//               bodyColor: '#e5e7eb',
//               borderColor: 'rgba(255, 255, 255, 0.1)',
//               borderWidth: 1,
//               callbacks: {
//                 label: function(context) {
//                   return `Population: ${context.raw.toLocaleString()}`;
//                 }
//               }
//             }
//           },
//           scales: {
//             y: {
//               beginAtZero: true,
//               ticks: {
//                 color: '#9ca3af',
//                 callback: function(value) {
//                   return value.toLocaleString();
//                 }
//               },
//               grid: {
//                 color: 'rgba(255, 255, 255, 0.05)'
//               }
//             },
//             x: {
//               ticks: {
//                 color: '#9ca3af'
//               },
//               grid: {
//                 display: false
//               }
//             }
//           }
//         }
//       });
//     } catch (err) {
//       console.error("Chart initialization error:", err);
//     }

//     return () => {
//       if (chartInstance.current) {
//         chartInstance.current.destroy();
//       }
//     };
//   }, [populationData]);

//   if (!populationData || populationData.length === 0) {
//     return (
//       <div className="h-full w-full flex items-center justify-center bg-gray-700 rounded">
//         <p className="text-gray-400 italic">No population data available for chart</p>
//       </div>
//     );
//   }

//   return (
//     <div className="h-full w-full">
//       <canvas ref={chartRef} />
//     </div>
//   );
// };

// export default ViewCitydetailData;